export default __webpack_public_path__ + "static/media/training-illustration3.c65187e8.png";